<template>
  <div class="">
    <AlertInPage :type="AlertInPage.type" :msg="AlertInPage.msg" :delay="AlertInPage.delay"/>
    <form action="" method="post" enctype="multipart/form-data" class="form-horizontal">
      <!--<div class="alertList w100" v-if="!(Number(dataId)>0)">-->
      <!--{{$t('stostockalert.emptyIdAttention')}}-->
      <!--</div>-->
      <!--<table class="alertList w100" v-if="Number(dataId)>0">-->
      <!--<tr>-->
      <!--&lt;!&ndash;"id","id_element","stock_type","id_store","element_count_min","element_count_ideal","element_count_max"&ndash;&gt;-->
      <!--<th class="element">{{$t('stostockalert.store')}}</th>-->
      <!--<th class="element">{{$t('stostockalert.element_count_min')}}</th>-->
      <!--<th class="element">{{$t('stostockalert.element_count_ideal')}}</th>-->
      <!--<th class="element">{{$t('stostockalert.element_count_max')}}</th>-->
      <!--</tr>-->
      <!--<template v-for="(row, i) in this.modeldata">-->
      <!--<tr>-->
      <!--<td class="element" v-if="row.id==='stostockalert.companylevel'">{{$t('stostockalert.companylevel')}}</td>-->
      <!--<td class="element" v-if="row.id!=='stostockalert.companylevel'">{{row.id}}</td>-->
      <!--<td class="element"><input v-model="modeldata[i].element_count_min" type="text" placeholder="" class="form-control " :name="modeldata[i].element_count_min"-->
      <!--v-validate="'numeric'" data-vv-as="field" v-bind:class="{'is-invalid':errors.has(modeldata[i].element_count_min)}"></td>-->
      <!--<td class="element"><input v-model="modeldata[i].element_count_ideal" type="text" placeholder="" class="form-control " :name="modeldata[i].element_count_ideal"-->
      <!--v-validate="'numeric'" data-vv-as="field" v-bind:class="{'is-invalid':errors.has(modeldata[i].element_count_ideal)}"></td>-->
      <!--<td class="element"><input v-model="modeldata[i].element_count_max" type="text" placeholder="" class="form-control " :name="modeldata[i].element_count_max"-->
      <!--v-validate="'numeric'" data-vv-as="field" v-bind:class="{'is-invalid':errors.has(modeldata[i].element_count_max)}"></td>-->
      <!--</tr>-->
      <!--</template>-->
      <!--</table>-->
      <div class="stockSaveButtonContainer" v-if="true">
        <button type="button"  :class="btnClass" v-on:click="open()">
          <i class="fa fa-dot-circle-o"></i> {{$t('global.open')}}
        </button>
        &nbsp;
        <button type="button"  :class="btnClass" v-on:click="download()">
          <i class="fa fa-dot-circle-o"></i> {{$t('global.download')}}
        </button>
        &nbsp;
        <button type="button"  :class="btnClass" v-on:click="print()">
          <i class="fa fa-dot-circle-o"></i> {{$t('global.print')}}
        </button>

      </div>

    </form>
  </div>
</template>

<script>
  import Api from '@/api/Api';
  import Helper from '@/helper/Helper';
  import AlertInPage from '@/components/AlertInPage.vue';

  import pdfMake from "pdfmake/build/pdfmake";
  import pdfFonts from "pdfmake/build/vfs_fonts";
  pdfMake.vfs = pdfFonts.pdfMake.vfs;


  export default {
    name: 'PdfMake',
    data(){
      return {
        num: 0
        , visibleSaveButton: false
        , data: []
        , modeldata: {}
        , AlertInPage: {
          type: "", // primary secondary success danger warning info light dark
          msg: "",
          delay: 5000,
        }
      }
    },
    mounted() {
      console.log("PdfMake");
      const modul = this;
    },
    props: {
      dataId: String,
//      stores: Array,

      docDefinition: Object,
      docName: String,
      btnClass: {
        type: String,
        default: 'btn btn-primary', //  h:i:s
      },

    },
    watch: {
      dataId: function (newdata, olddata) {
        const modul = this;
        if (newdata !== olddata) {
        }
      },
      data: function (newdata, olddata) {
        const modul = this;
//        modul.generateModeldata();
      },
    },
    methods: {

      open(){
        const modul = this;
//        const content = modul.content();
//        const docDefinition = {
//          content: content
//        };
//        pdfMake.createPdf(docDefinition).open();
        pdfMake.createPdf(modul.docDefinition).open();
      },
      download(){
        const modul = this;
//        const content = modul.content();
//        const docDefinition = {
//          content: content
//        };
        pdfMake.createPdf(modul.docDefinition).download(modul.docName); // "optionalName.pdf"
      },
      print(){
        const modul = this;
//        const content = modul.content();
//        const docDefinition = {
//          content: content
//        };
        pdfMake.createPdf(modul.docDefinition).print();
      },


//      generateModeldata(){
//        const modul = this;
//        const modeldata = {};
//        Array.prototype.forEach.call(modul.data, function (e, x) {
//          if (Number(e.stock_type) === 1) {
//            if (!modeldata['company']) {
//              modeldata['company'] = {};
//            }
//            modeldata['company']['id'] = 'stostockalert.companylevel';
//            modeldata['company']['stock_type'] = e.stock_type;
//            modeldata['company']['id_store'] = e.id_store;
//            modeldata['company']['element_count_min'] = e.element_count_min;
//            modeldata['company']['element_count_ideal'] = e.element_count_ideal;
//            modeldata['company']['element_count_max'] = e.element_count_max;
//          } else if (Number(e.stock_type) === 2) {
//            if (!modeldata['store' + e.id_store]) {
//              modeldata['store' + e.id_store] = {};
//            }
//            modeldata['store' + e.id_store]['stock_type'] = e.stock_type;
//            modeldata['store' + e.id_store]['id'] = e.storetext;
//            modeldata['store' + e.id_store]['id_store'] = e.id_store;
//            modeldata['store' + e.id_store]['element_count_min'] = e.element_count_min;
//            modeldata['store' + e.id_store]['element_count_ideal'] = e.element_count_ideal;
//            modeldata['store' + e.id_store]['element_count_max'] = e.element_count_max;
//          }
//        });
//        if (!modeldata['company']) {
//          modeldata['company'] = {};
//          modeldata['company']['id'] = 'stostockalert.companylevel';
//          modeldata['company']['stock_type'] = 1;
//          modeldata['company']['id_store'] = "";
//          modeldata['company']['element_count_min'] = "";
//          modeldata['company']['element_count_ideal'] = "";
//          modeldata['company']['element_count_max'] = "";
//        }
//        console.log(modeldata);
//        modul.modeldata = modeldata;
//      },
//      getStockAlertByElementId(id){
//        const modul = this;
//        if (Number(id) > 0) {
//          Api.getStockAlertByElementId(id).then(function (res) {
//            console.log(res);
//            if (res && res.result && res.data) {
//              modul.data = res.data;
//            }
//          });
//        }
//      },
//      save(){
//        const modul = this;
//        modul.$validator.validateAll().then((result) => {
//          if (result) {
//
//            const data = [];
//            for (let i in modul.modeldata) {
//              if (!modul.modeldata.hasOwnProperty(i)) {
//                continue;
//              }
//              const row = {};
//              const e = modul.modeldata[i];
//              row.id_element = modul.dataId;
//              row.stock_type = e.stock_type;
//              row.id_store = e.id_store;
//              row.element_count_min = e.element_count_min;
//              row.element_count_ideal = e.element_count_ideal;
//              row.element_count_max = e.element_count_max;
//              data.push(row);
//            }
//
//
//            console.log(data);
////            return;
////            const data = Helper.makeFilteredObjectByKeys(modul.data, ["id", "id_element", "stock_type", "id_store", "element_count_min", "element_count_ideal", "element_count_max"]);
//            Api.saveStockAlerts({data:data}).then(function (res) {
//              if (res && res.result) {
//                if (res && res.data.id) {
//                  modul.data.id = res.data.id;
//                }
//                modul.AlertInPage.msg = "form.save_succes";
//                modul.AlertInPage.type = "success";
//                setTimeout(function (e) {
//                  modul.AlertInPage.msg = "";
//                }, Number(modul.AlertInPage.delay));
//              } else {
//                modul.AlertInPage.msg = "form.save_error";
//                modul.AlertInPage.type = "danger";
//                setTimeout(function (e) {
//                  modul.AlertInPage.msg = "";
//                }, Number(modul.AlertInPage.delay));
//              }
//            });
//
//          } else {
//            modul.AlertInPage.msg = "form.save_error";
//            modul.AlertInPage.type = "danger";
//          }
//        });
//      }


      content(){
        const obj = {
          style: 'tableExampleX',
          color: '#444',
// 			layout: 'noBorders',
          table: {
            widths: [34, 34, 34, 34, 34, 34, 34, 34, 34, 34, 34, 34],
            headerRows: 2,
            body: [
              [
                {text: 'Logo,\n és név,\n cím', style: 'X', colSpan: 6, alignment: 'left', border: [false, false, false, true]}, {}, {}, {}, {}, {},
                {text: 'Kapcsolat,\n adószám,\n web', style: 'X', colSpan: 6, alignment: 'right', border: [false, false, false, true]}, {}, {}, {}, {}, {}
              ],
              [{text: '\nSzállítólevél\n', style: 'tableHeader', colSpan: 12, alignment: 'center', border: [false, false, false, false]}, {}, {}, {}, {}, {}, {}, {}, {}, {}, {}, {}],

              [
                {text: 'Bizonylat sorszám', style: 'x', colSpan: 6, alignment: 'left', border: [false, false, false, true]}, {}, {}, {}, {}, {},
                {text: '0000/xxx/111', style: 'x', colSpan: 6, alignment: 'right', border: [false, false, false, true]}, {}, {}, {}, {}, {}
              ],
              [
                {text: 'Szállító', style: 'tableHeader', colSpan: 6, alignment: 'left', border: [false, false, false, false]}, {}, {}, {}, {}, {},
                {text: 'Vevő', style: 'tableHeader', colSpan: 6, alignment: 'left', border: [true, false, false, false]}, {}, {}, {}, {}, {}
              ],
              [
                {text: 'Cdfggg utca 4\nBankszámlaszám:\nAdószám:\nKözösségi adószám:\n', style: 'x', colSpan: 6, alignment: 'left', border: [false, false, false, true]}, {}, {}, {}, {}, {},
                {text: 'Cdfggg utca 4\nBankszámlaszám:\nAdószám:\nKözösségi adószám:\n', style: 'x', colSpan: 6, alignment: 'left', border: [true, false, false, true]}, {}, {}, {}, {}, {}
              ],
              [
                {text: 'Szállítási mód:\n', style: 'x', colSpan: 8, alignment: 'left', border: [false, false, false, false]}, {}, {}, {}, {}, {}, {}, {},
                {text: 'Kelte:', style: 'x', colSpan: 2, alignment: 'left', border: [false, false, false, false]}, {},
                {text: 'Teljesítés:', style: 'x', colSpan: 2, alignment: 'left', border: [false, false, false, false]}, {}
              ],
              [
                {text: 'Személyes átvétel', style: 'x', colSpan: 8, alignment: 'left', border: [false, false, false, false]}, {}, {}, {}, {}, {}, {}, {},
                {text: '2020.01.01', style: 'x', colSpan: 2, alignment: 'left', border: [false, false, false, false]}, {},
                {text: '2020.01.02', style: 'x', colSpan: 2, alignment: 'left', border: [false, false, false, false]}, {}
              ],
              [{text: '', style: '', colSpan: 12, alignment: 'center', border: [false, false, false, true]}, {}, {}, {}, {}, {}, {}, {}, {}, {}, {}, {}],

              [
                {text: 'Megnevezés', style: 'fontn9', colSpan: 6, alignment: 'left', border: [false, false, false, false]}, {}, {}, {}, {},
                {text: 'Raktár', style: 'fontn8', colSpan: 1, alignment: 'left', border: [false, false, false, false]},
                {text: 'Egységár', style: 'fontn8', colSpan: 1, alignment: 'left', border: [false, false, false, false]},
                {text: 'Mennyiség', style: 'fontn8', colSpan: 1, alignment: 'left', border: [false, false, false, false]},
                {text: 'Mennyiség egysége', style: 'fontn8', colSpan: 1, alignment: 'left', border: [false, false, false, false]},
                {text: 'Áfa', style: 'fontn8', colSpan: 1, alignment: 'left', border: [false, false, false, false]},
                {text: 'Netto', style: 'fontn8', colSpan: 1, alignment: 'left', border: [false, false, false, false]},
                {text: 'brutto', style: 'fontn8', colSpan: 1, alignment: 'left', border: [false, false, false, false]},
              ],
              [
                {text: 'Terméknév', style: 'fontn9', colSpan: 6, alignment: 'left', border: [false, false, false, false]}, {}, {}, {}, {},
                {text: 'Központi', style: 'fontn8', colSpan: 1, alignment: 'left', border: [false, false, false, false]},
                {text: '100', style: 'fontn8', colSpan: 1, alignment: 'left', border: [false, false, false, false]},
                {text: '10', style: 'fontn8', colSpan: 1, alignment: 'left', border: [false, false, false, false]},
                {text: 'Db', style: 'fontn8', colSpan: 1, alignment: 'left', border: [false, false, false, false]},
                {text: '27', style: 'fontn8', colSpan: 1, alignment: 'left', border: [false, false, false, false]},
                {text: '1000', style: 'fontn8', colSpan: 1, alignment: 'left', border: [false, false, false, false]},
                {text: '1270', style: 'fontn8', colSpan: 1, alignment: 'left', border: [false, false, false, false]},
              ],
              [{text: '', style: '', colSpan: 12, alignment: 'center', border: [false, false, false, true]}, {}, {}, {}, {}, {}, {}, {}, {}, {}, {}, {}],
              [
                {text: '', style: 'x', colSpan: 8, alignment: 'left', border: [false, false, false, false]}, {}, {}, {}, {}, {}, {}, {},
                {text: '', style: 'x', colSpan: 2, alignment: 'left', border: [false, false, false, false]}, {},
                {text: '2020.01.02', style: 'x', colSpan: 2, alignment: 'left', border: [false, false, false, false]}, {}
              ],

            ]
          }
        };
        return obj
      }
    },
    components: {
      AlertInPage,
    },

  };
</script>

<style scoped="">
  .stockSaveButtonContainer {
    padding: 8px 0 0 0px
  }

  [aria-invalid="true"] {
    border: 1px solid red;
  }

  .alertList td {
    padding: 1px;
  }
</style>
